module.exports = __webpack_public_path__ + "static/media/trial3_3.732ad3ca.png";